import { Button, EmptyState, RadioGroupField } from '@payaca/ambrosia';
import {
  CUSTOM_FIELD_TYPE_READABLE_NAME_MAP,
  CustomFieldType,
} from '@payaca/custom-fields';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';

type TFieldsetChildItem = {
  id: string;
  identification: { label?: string; identifier: string };
  type: CustomFieldType;
};

export type TFieldsetChildrenListProps = {
  fields: TFieldsetChildItem[];
  selectedId: string | undefined;
  onSelect: (id: string) => void;
  onRemove: (index: number) => void;
  onMove: (oldIndex: number, newIndex: number) => void;
  canRemoveChild: (index: number) => boolean;
  hasError: (index: number) => boolean;
  emptyStateText: string;
};

const FieldsetChildrenList: FC<TFieldsetChildrenListProps> = (props) => {
  const {
    fields,
    selectedId,
    onSelect,
    onRemove,
    onMove,
    canRemoveChild,
    hasError,
    emptyStateText,
  } = props;

  return (
    <>
      <RadioGroupField
        value={selectedId || ''}
        onChange={onSelect}
        hiddenInput
        emphasised
        sortable
        onDragEnd={(event) => {
          const { active, over } = event;
          if (!over) return;

          const oldIndex = fields.findIndex((field) => field.id === active.id);
          const newIndex = fields.findIndex((field) => field.id === over.id);

          onMove(oldIndex, newIndex);
        }}
        options={fields.map((field, index) => {
          const canRemove = canRemoveChild(index);

          return {
            id: field.id,
            className: clstx(
              hasError(index) && 'ring-1 ring-red-500 rounded-lg'
            ),
            label: (
              <div className="flex gap-4 w-full items-center">
                <h4>{field.identification?.label || '(unnamed)'}</h4>
                <h4 className="text-gray-500 ml-auto">
                  {CUSTOM_FIELD_TYPE_READABLE_NAME_MAP[field.type]}
                </h4>
                <Button
                  size="xs"
                  variant="white"
                  onClick={() => {
                    if (!canRemove) return;
                    onRemove(index);
                  }}
                  disabled={!canRemove}
                >
                  Remove
                </Button>
              </div>
            ),
            value: field.id,
          };
        })}
      />

      {fields.length === 0 && (
        <EmptyState iconName="link-broken-01.3" text={emptyStateText} />
      )}
    </>
  );
};

export default FieldsetChildrenList;
